import hostedNetbox from "public/application-services/icons/hosted-netbox.png";
import { ContentCard } from "@/components/contentCard";

export const HOSTED_NETBOX_FEATURES = {
  title: "Features of Hosted NetBox",
  list: [
    {
      image: hostedNetbox,
      title: "Comprehensive Network Documentation",
      content: (
        <ContentCard
          points={[
            "IP Address Management (IPAM) to track and allocate IPs efficiently.",
            "Data Center Infrastructure Management (DCIM) for documenting racks, devices, and connections.",
            "Circuit management to monitor and maintain physical and virtual circuits.",
          ]}
        />
      ),
    },
    {
      image: hostedNetbox,
      title: "Scalability, Flexibility & Expert Management",
      content: (
        <ContentCard
          points={[
            "Elastic resource allocation to support network growth and workload changes.",
            "Multi-user collaboration with role-based access for teamwork across departments.",
            "Managed services & customization assistance for seamless updates and network optimization.",
          ]}
        />
      ),
    },
    {
      image: hostedNetbox,
      title: "Robust Security",
      content: (
        <ContentCard
          points={[
            "Automated backups to ensure data integrity and disaster recovery.",
            "Access controls to safeguard sensitive network information with defined user roles.",
          ]}
        />
      ),
    },
    {
      image: hostedNetbox,
      title: "Seamless Integration",
      content: (
        <ContentCard
          points={[
            "API access for smooth integration with network monitoring and automation tools.",
            "Plugin support to extend functionality based on operational needs.",
          ]}
        />
      ),
    },
  ],
};
